module.exports = __webpack_public_path__ + "img/seaportal-logo.9f725689.png";